import styled from "styled-components";
import Filters from "../Filters/index.js";
import FiltersButton from "../FiltersButton/index.js";
import MapButtons from "../MapButtons/index.js";
import DistrictDetail from "../DistrictDetail";
import {
  Legend as LegendComponent
} from "../Legend/styled.js";

export const Icon = styled.img`
  width: 15px;
`;

export const Title = styled.h1`
  font-family: "reader";
  font-size: 18px;
  font-weight: 700;
  width: 100%;
  padding: 5px 18px;
`;

export const Copyright = styled.div`
  font-family: "reader";
  position: absolute;
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 12px;
  z-index: 1;
  bottom: 10px;
  right: 15px;

  img {
    margin-right: 5px;
  }
`;

export const AppFilters = styled(Filters)`
  position: absolute;
  z-index: 3;

  height: 100%;
  width: 100%;

  @media (min-width: 640px) {
    top: 0;
    bottom: 0;
    width: 310px;
  }
`;

export const DistrictDetailPanel = styled(DistrictDetail)`
  position: absolute;
  z-index: 3;

  height: 100%;
  width: 100%;

  @media (min-width: 640px) {
    top: 0;
    bottom: 0;
    width: 310px;
  }
`;

export const MapFiltersButton = styled(FiltersButton)`
  display: none;

  @media (min-width: 640px) {
    display: flex;
    position: absolute;
    top: 125px;
    left: 20px;
    z-index: 2;
  }
`;

export const Legend = styled(LegendComponent)`
    bottom: 10px;
`;

export const StateMapButtons = styled(MapButtons)`
  bottom: 20px !important;

  @media (min-width: 640px) {
    bottom: 90px !important;
  }
`;
